export const navMenuItemsData = ref<INavMenuItems[]>([
	{ label: 'Strona główna', icon: 'home', route: '/panel' },
	{
		label: 'Klienci',
		icon: 'clients',
		key: 'clients',
		items: [
			{ label: 'Diety klientów', route: '/panel/clients/orders' },
			{ label: 'Transakcje', route: '/panel/clients/transactions' },
			{ label: 'Lista klientów', route: '/panel/clients/list' },
			{ label: 'Opinie klientów', route: '/panel/clients/opinions' },
			{ label: 'Lista rankingowa', route: '/panel/clients/rankings' },
			{ label: 'Dostawy klientów', route: '/panel/clients/packages' },
			{ label: 'Raport zamówień', route: '/panel/clients/reports' },
			{ label: 'Baza wysyłkowa', route: '/panel/clients/newsletter' },
		],
	},
	{
		label: 'Diety',
		icon: 'diets',
		key: 'diets',
		items: [
			{ label: 'Lista diet', route: '/panel/diets/list' },
			{ label: 'Menu', route: '/panel/diets/menu' },
			{ label: 'Dania', route: '/panel/diets/meals' },
			{ label: 'Mealprepy', route: '/panel/diets/mealpreps' },
			{ label: 'Surowce', route: '/panel/diets/materials' },
			{ label: 'Receptury', route: '/panel/diets/semi-products' },
			{ label: 'Alergeny', route: '/panel/diets/allergens' },
			{ label: 'Macierze rozmiarów', route: '/panel/diets/size-matrices' },
			{ label: 'Analiza rentowności', route: '/panel/diets/profitability-analysis' },
			{ label: 'Błędy produkcji', route: '/panel/diets/production-errors' },
			{ label: 'Wyszukiwarka', route: '/panel/diets/wyszukiwarka', icon: 'search' },
		],
	},
	{
		label: 'Dodatki',
		icon: 'addons',
		key: 'addons',
		items: [
			{ label: 'Lista dodatków', route: '/panel/addons/list' },
			{ label: 'Kategorie dodatków', route: '/panel/addons/categories' },
		],
	},
	{
		label: 'Punkty i Gadżety',
		icon: 'points',
		key: 'points and gadgets',
		items: [
			{ label: 'Punkty', route: '/panel/points' },
			{
				label: 'Kategoria i Partnerzy',
				icon: 'award',
				iconHiddenInSidebar: true,
				route: '/panel/gadgets/category-and-partners',
			},
			{ label: 'Gadżety', icon: 'award', iconHiddenInSidebar: true, route: '/panel/gadgets/list' },
			{ label: 'Magazyny', icon: 'award', iconHiddenInSidebar: true, route: '/panel/gadgets/warehouse' },
			{
				label: 'Stany magazynowe',
				icon: 'award',
				iconHiddenInSidebar: true,
				route: '/panel/gadgets/warehouse-status',
			},
			{ label: 'Zamówienia gadżetów', icon: 'award', iconHiddenInSidebar: true, route: '/panel/gadgets/orders' },
		],
	},
	{
		label: 'Promocje & Kampanie',
		icon: 'sale',
		key: 'promo',
		items: [
			{ label: 'Kampanie rabatowe', route: '/panel/campaigns' },
			{ label: 'Kody rabatowe', route: '/panel/discount-codes' },
			{ label: 'Klienci B2B', route: '/panel/b2b-clients' },
			{ label: 'Raporty', route: '/panel/campaigns/reports' },
		],
	},
	{
		label: 'Dostawy',
		icon: 'delivery',
		key: 'deliveries',
		items: [
			{ label: 'Lista dostawców', route: '/panel/deliveries/list' },
			{ label: 'Lista regionów', route: '/panel/deliveries/regions' },
			{ label: 'Harmonogram dostaw', route: '/panel/deliveries/schedule' },
			{ label: 'Dzienne dostawy', route: '/panel/deliveries/daily-deliveries' },
			{ label: 'Export e-mail (numery toreb)', route: '/panel/deliveries/box-packagings' },
			{ label: 'Export surowców', route: '/panel/deliveries/export-commodities' },
			{ label: 'Centra dystrybucyjne', route: '/panel/deliveries/centers' },
			{ label: 'Zakłady produkcyjne', route: '/panel/deliveries/factories' },
			{ label: 'Warunki logistyczne', route: '/panel/deliveries/minimum-logistics' },
		],
	},
	{ label: 'Cenniki', icon: 'pricelist', route: '/panel/price-lists' },
	{ label: 'Tagi', icon: 'tags', route: '/panel/tags' },
	{ label: 'Moduł reklamacyjny ', icon: 'complaint', route: '/panel/complaints' },
	{ label: 'Zamówienia wewnętrzne', icon: 'basket', route: '/panel/internal-orders' },
	{ label: 'Zamówienia zewnętrzne', icon: 'basket', route: '/panel/external-orders' },
	{
		label: 'Ustawienia produkcji',
		icon: 'settings',
		key: 'production-settings',
		items: [
			{ label: 'Typy produktów', route: '/panel/production-settings/products-types' },
			{ label: 'Typy maszyn', route: '/panel/production-settings/machine-types' },
			{ label: 'Maszyny', route: '/panel/production-settings/machines' },
			{ label: 'Gniazda', route: '/panel/production-settings/sockets' },
		],
	},
	{
		label: 'Ustawienia',
		icon: 'settings',
		key: 'employees',
		items: [
			{ label: 'Konta pracowników', route: '/panel/employees/list' },
			{ label: 'Konta kurierów', route: '/panel/employees/couriers' },
			{ label: 'System', route: '/panel/system' },
			{ label: 'Wersja aplikacji', route: '/panel/system/app-version' },
			{ label: 'Limity portfeli', route: '/panel/system/wallet-limits' },
		],
	},
])

interface IRoute {
	route: string
	permissions: EEmployeePermission[] | null
}

// to restrict view for panel routes
export const restrictViewRoutes: IRoute[] = [
	//clients
	{ route: '/panel/clients/orders', permissions: [EEmployeePermission.VIEW_CLIENT_ORDERS] },
	{ route: '/panel/clients/transactions', permissions: [EEmployeePermission.VIEW_CLIENT_TRANSACTION_LIST] },
	{ route: '/panel/clients/list', permissions: [EEmployeePermission.VIEW_CLIENT_LIST] },
	{ route: '/panel/clients/opinions', permissions: [EEmployeePermission.VIEW_CLIENT_REVIEWS] },
	{ route: '/panel/clients/reports', permissions: [EEmployeePermission.VIEW_ORDER_REPORTS] },
	{ route: '/panel/clients/newsletter', permissions: [EEmployeePermission.VIEW_NEWSLETTER] },
	//diets
	{ route: '/panel/diets/list', permissions: [EEmployeePermission.VIEW_DIET_LIST] },
	{ route: '/panel/diets/menu', permissions: [EEmployeePermission.VIEW_MENU] },
	{ route: '/panel/diets/meals', permissions: [EEmployeePermission.VIEW_MEAL_LIST] },
	{ route: '/panel/diets/mealpreps', permissions: [EEmployeePermission.VIEW_MEALPREP_LIST] },
	{ route: '/panel/diets/materials', permissions: [EEmployeePermission.VIEW_RAW_MATERIALS_LIST] },
	{ route: '/panel/diets/semi-products', permissions: [EEmployeePermission.VIEW_MEAL_LIST] },
	{ route: '/panel/diets/allergens', permissions: [EEmployeePermission.VIEW_MEAL_LIST] },
	{ route: '/panel/diets/size-matrices', permissions: [EEmployeePermission.VIEW_SIZE_MATRICES] },
	{ route: '/panel/diets/production-errors', permissions: [EEmployeePermission.VIEW_MES_ERROR_REPORTS] },
	{ route: '/panel/diets/wyszukiwarka', permissions: [EEmployeePermission.VIEW_RAW_MATERIALS_LIST] },

	//addons
	{ route: '/panel/addons/list', permissions: [EEmployeePermission.VIEW_ADDITIVES_LIST] },
	{ route: '/panel/addons/categories', permissions: [EEmployeePermission.VIEW_ADDITIVES_LIST] },

	//points
	{ route: '/panel/points', permissions: [EEmployeePermission.VIEW_POINT_ACTIONS_LIST] },
	//campaigns
	// Sekcja kampanii widoczna i dostępna bez nowych uprawnień (view_discount_campaigns /
	// view_campaign_reports / view_campaign_settings nie są jeszcze przypisane do ról).
	// Przywrócić te gate'y, gdy uprawnienia kampanii zostaną nadane rolom przed produkcją.
	{ route: '/panel/campaigns', permissions: null },
	{ route: '/panel/campaigns/reports', permissions: null },
	//discount-codes
	{ route: '/panel/discount-codes', permissions: [EEmployeePermission.VIEW_DISCOUNT_CODES] },
	//b2b-clients - TODO: dedykowane uprawnienie VIEW_B2B_CLIENTS gdy backend je udostępni
	{ route: '/panel/b2b-clients', permissions: [EEmployeePermission.VIEW_DISCOUNT_CODES] },
	{ route: '/panel/discounts/influencers', permissions: [EEmployeePermission.VIEW_DISCOUNT_CODES] },
	{ route: '/panel/discounts/promotions', permissions: [EEmployeePermission.VIEW_DISCOUNT_CODES] },
	//deliveries
	{ route: '/panel/deliveries/list', permissions: [EEmployeePermission.VIEW_DELIVERY_LIST] },
	{ route: '/panel/deliveries/regions', permissions: [EEmployeePermission.VIEW_REGIONS_LIST] },
	{ route: '/panel/deliveries/schedule', permissions: [EEmployeePermission.VIEW_DELIVERY_SCHEDULE] },
	{ route: '/panel/deliveries/box-packagings', permissions: [EEmployeePermission.VIEW_DELIVERY_LIST] },
	{ route: '/panel/deliveries/centers', permissions: [EEmployeePermission.VIEW_DISTRIBUTION_CENTERS] },
	{ route: '/panel/deliveries/factories', permissions: [EEmployeePermission.VIEW_SUPPLIERS_LIST] },
	//price-lists
	{ route: '/panel/price-lists', permissions: [EEmployeePermission.VIEW_PRICE_LISTS] },
	//tags
	{ route: '/panel/tags', permissions: [EEmployeePermission.VIEW_MEAL_LIST] },
	//complaints
	{ route: '/panel/complaints', permissions: [EEmployeePermission.VIEW_CLIENT_REQUESTS_LIST] },
	//internal-orders
	{ route: '/panel/internal-orders', permissions: [EEmployeePermission.MANAGE_INTERNAL_ORDERS] },
	//external-orders
	{ route: '/panel/external-orders', permissions: [EEmployeePermission.MANAGE_EXTERNAL_ORDERS] },
	//employees
	{ route: '/panel/employees/list', permissions: [EEmployeePermission.VIEW_USER_ACCOUNTS] },
	{ route: '/panel/employees/couriers', permissions: [EEmployeePermission.EDIT_ADMIN_PERMISSIONS] },
	//production-settings
	{ route: '/panel/production-settings/machines', permissions: [EEmployeePermission.VIEW_PRODUCTION_MACHINES] },
	{ route: '/panel/production-settings/sockets', permissions: [EEmployeePermission.VIEW_PRODUCTION_SOCKETS] },
	//system
	{ route: '/panel/system/wallet-limits', permissions: [EEmployeePermission.MANAGE_WALLET_LIMITS] },
	{ route: '/panel/system', permissions: [EEmployeePermission.MANAGE_SYSTEM] },
	//gadgets
	{ route: '/panel/gadgets/list', permissions: [EEmployeePermission.VIEW_GADGETS] },
	{ route: '/panel/gadgets/category-and-partners', permissions: [EEmployeePermission.VIEW_GADGETS] },
	{ route: '/panel/gadgets/warehouse', permissions: [EEmployeePermission.VIEW_GADGETS_WAREHOUSES] },
	{ route: '/panel/gadgets/warehouse-status', permissions: [EEmployeePermission.VIEW_GADGETS_WAREHOUSE_STATUS] },
	{ route: '/panel/gadgets/orders', permissions: [EEmployeePermission.VIEW_GADGETS_ORDERS] },
]

// for grouping routes with the same segments e.g. /panel/diets
// to avoid adding permissions to each route
// as to see main route user should have permission to see at least some subroutes
const addMainRoutes = () => {
	const newRoutes: Record<string, EEmployeePermission[]> = {}
	restrictViewRoutes.forEach(route => {
		if (!route.permissions) return
		const splittedRoute = route.route.split('/')
		const segment = splittedRoute?.[2]
		if (!segment || (segment && !splittedRoute[3])) return
		if (!newRoutes[segment]) {
			newRoutes[segment] = [...route.permissions]
		} else {
			newRoutes[segment].push(...route.permissions)
		}
	})
	Object.keys(newRoutes).forEach(key => {
		const uniquePermissions = [...new Set(newRoutes[key])] as EEmployeePermission[]
		restrictViewRoutes.push({ route: `/panel/${key}`, permissions: uniquePermissions })
	})
}
addMainRoutes()

// adding order for items and subitems and filtering by permissions
// it have to match route or key
export const navMenuItems = computed(() => {
	const userStore = useUserStore()
	const { isAllowedAppVersionAccess } = useAppVersionAccess()
	return (
		navMenuItemsData.value
			.filter(i => {
				const commonRoute = restrictViewRoutes.find(
					obj => obj.route === i.route || obj.route === `/panel/${i.key}`,
				)
				if (commonRoute) {
					return userStore.hasPermission(commonRoute.permissions)
				}
				return true
			})
			.map((item, itemIndex) => {
				const newItem = { ...item, order: itemIndex }

				if (item.items) {
					newItem.items = item.items
						.filter(i => {
							const userEmail = userStore.getUser?.email ?? ''
							if (
								i.route === '/panel/system/app-version' &&
								!isAllowedAppVersionAccess(userEmail, userStore.isSuperAdmin())
							) {
								return false
							}
							const commonRoute = restrictViewRoutes.find(obj => obj.route === i.route)
							if (commonRoute) {
								return userStore.hasPermission(commonRoute.permissions)
							}
							return true
						})
						.map((subItem, subItemIndex) => ({ ...subItem, order: subItemIndex }))
				}

				return newItem
			})
			// Grupy bez `route` (np. 'promo') nie są gatowane jednym uprawnieniem - ukrywamy je,
			// gdy po przefiltrowaniu pozycji użytkownik nie ma dostępu do żadnej z nich.
			.filter(item => !item.items || item.items.length > 0)
	)
})
